﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catFormatosDeVenta } from "../../Categorias y Estados/catFormatosDeVenta";
import { catGruposProducto } from "../../Categorias y Estados/catGruposProducto";
import { catTiposCodigoBarra } from "../../Categorias y Estados/catTiposCodigoBarra";
import { estActivo } from "../../Categorias y Estados/estActivo";
import { Productos } from "../../Productos/Productos";
import { Clientes } from "../Clientes";

const columns = () =>
(
    {
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.PK, prompt: 'Cliente Id' }),
        c_producto_id: new EntityColumn<string>({ name: 'c_producto_id', type: 'char', length: 20, flags: c.PK, prompt: 'Producto Id' }),
        // Fake columns para poder crear un producto desde esta entidad
        c_fileprocess_id: new EntityColumn<string>({ name: 'c_fileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Fileprocess Id' }),
        vc_codigoproducto: new EntityColumn<string>({ name: 'vc_codigoproducto', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Código interno' }),
        vc_codigobarras: new EntityColumn<string>({ name: 'vc_codigobarras', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Código de barras' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        vc_nombrecorto: new EntityColumn<string>({ name: 'vc_nombrecorto', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Nombre corto' }),
        vc_GTIN8: new EntityColumn<string>({ name: 'vc_GTIN8', type: 'varchar', length: 8, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'GTIN8' }),
        vc_EAN13: new EntityColumn<string>({ name: 'vc_EAN13', type: 'varchar', length: 13, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'EAN13' }),
        vc_UPCA: new EntityColumn<string>({ name: 'vc_UPCA', type: 'varchar', length: 12, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'UPCA' }),
        vc_DUN14: new EntityColumn<string>({ name: 'vc_DUN14', type: 'varchar', length: 14, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'DUN14' }),
        vc_GS1128: new EntityColumn<string>({ name: 'vc_GS1128', type: 'varchar', length: 128, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'GS1128' }),
        n_precio: new EntityColumn<number>({ name: 'n_precio', type: 'decimal', length: 14, scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Precio' }),
        vc_peso: new EntityColumn<string>({ name: 'vc_peso', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Peso' }),
        vc_medida: new EntityColumn<string>({ name: 'vc_medida', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Medida' }),
        vc_unidadesxbulto: new EntityColumn<string>({ name: 'vc_unidadesxbulto', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Unidades' }),
        c_tipocodigobarra_id: new EntityColumn<string>({ name: 'c_tipocodigobarra_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Tipo de codigobarra Id' }),
        vc_gruposproducto: new EntityColumn<string[]>({ name: 'vc_gruposproducto', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Grupo', isArray: true }),
        vc_formatosproducto: new EntityColumn<string[]>({ name: 'vc_formatosproducto', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Formato', isArray: true }),
        vc_fotoguid: new EntityColumn<string>({ name: 'vc_fotoguid', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fotoguid' }),
        c_activo_id: new EntityColumn<string>({ name: 'c_activo_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Estado' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        clpr_brwStandard: { name: 'clpr_brwStandard', keyMappings: { c_producto_id: 0 } },
        clpr_brwNoEnCliente: { name: 'clpr_brwNoEnCliente', keyMappings: { c_producto_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        },

        'Productos': {
            name: 'Productos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Productos(client, parentKeys)
        },

        'TiposCodigoBarra': {
            name: 'TiposCodigoBarra',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposCodigoBarra(client, parentKeys)
        },

        'GruposProducto': {
            name: 'GruposProducto',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catGruposProducto(client, parentKeys)
        },
        'FormatosDeVenta': {
            name: 'FormatosDeVenta',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catFormatosDeVenta(client, parentKeys)
        },
        'Activo': {
            name: 'Activo',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new estActivo(client, parentKeys)
        }
    }
)

export class ClientesProductosDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('ClientesProductos');
    }
}